// apiEndpoints.js - Zentrale Konfiguration aller API-Endpoints
export const BASE_URL = process.env.REACT_APP_DATABASE_BASE_URL || 'https://eu-central-1.aws.data.mongodb-api.com/app/data-ywwpoom/endpoint';

/**
 * API-Endpunkte für die Anwendung
 * Wird verwendet, um die URLs der API-Endpunkte zu zentralisieren
 */
export const API_ENDPOINTS = {
  // Base URL für alle API-Endpunkte
  BASE_URL,
  // Authentifizierung
  LOGIN: `${BASE_URL}/login`,
  REGISTER: `${BASE_URL}/register`,
  PASSWORD: `${BASE_URL}/newPassword`,
  EMPLOYEE: `${BASE_URL}/getEmployee`,
  EMPLOYEE_LIST: `${BASE_URL}/employeeList`,
  
  // Zeit und Timer
  GET_TIMER_DATE: `${BASE_URL}/getTimerDate`,
  ADD_TIMER_DATE: `${BASE_URL}/addTimerDate`,
  DELETE_TIMER_DATE: `${BASE_URL}/deleteTimerDate`,
  GET_TIMES_V2: `${BASE_URL}/getTimesVersion2`,
  ADD_TIME: `${BASE_URL}/addTime`,
  ADD_CHANGE_REQUEST: `${BASE_URL}/addChangeRequest`,
  GET_ANNUAL_PLAN: `${BASE_URL}/getAnnualPlan`,
  ADD_ANNUAL_PLAN: `${BASE_URL}/addAnnualPlan`,
  GET_HOLIDAY_PLAN: `${BASE_URL}/getHolidayPlan`,
  
  // Projekte
  GET_PROJECTS: `${BASE_URL}/getProjects`,
  ADD_PROJECT: `${BASE_URL}/addProject`,
  CHANGE_PROJECT: `${BASE_URL}/changeProject`,
  DELETE_PROJECT: `${BASE_URL}/deleteProject`,
  
  // Kunden
  GET_CLIENTS: `${BASE_URL}/getClients`,
  ADD_CLIENT: `${BASE_URL}/addClient`,
  CHANGE_CLIENT: `${BASE_URL}/changeClient`,
  DELETE_CLIENT: `${BASE_URL}/deleteClient`,
  
  // Aufgaben
  GET_TASKS: `${BASE_URL}/getTasks`,
  ADD_TASK: `${BASE_URL}/addTask`,
  CHANGE_TASK: `${BASE_URL}/changeTask`,
  DELETE_TASK: `${BASE_URL}/deleteTask`,
  
  // Zeitklassen
  GET_TIME_CLASSES: `${BASE_URL}/getTimeClasses`,
  
  // Vertragsmodelle
  GET_CONTRACT_MODELS: `${BASE_URL}/getContractModels`,
};

export default API_ENDPOINTS;
